import { render } from "./GroupAdd.vue?vue&type=template&id=c158944c&scoped=true"
import script from "./GroupAdd.vue?vue&type=script&lang=js"
export * from "./GroupAdd.vue?vue&type=script&lang=js"

import "./GroupAdd.vue?vue&type=style&index=0&id=c158944c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c158944c"]])

export default __exports__